export default __webpack_public_path__ + "static/media/IMG_4274.cc63faab.jpg";